/**
 * XinYuanThink 思维链
 * zxw 
 * 创建时间：2025-12-15 
 */


import { Think } from '@ant-design/x';
import React from 'react';


const XinYuanThink = React.memo(props => {
    const [title, setTitle] = React.useState('思考中...');
    const [loading, setLoading] = React.useState(true);
    const [expand, setExpand] = React.useState(true);

    React.useEffect(() => {
        if (props.streamStatus === 'done') {
            setTitle('已思考');
            setLoading(false);
            setExpand(true);    // 默认不折叠
        }
    }, [props.streamStatus]);

    return (
        <Think title={title} loading={loading} expanded={expand} onClick={() => setExpand(!expand)}>
            {props.children}
        </Think>
    );
});

export default XinYuanThink;